
import Vue from 'vue'
import BusinessHours from '../../common/business-hours/index.vue'

export default Vue.extend({
  name: 'CashPointRow',
  components: {
    BusinessHours
  },
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    hours: {
      type: String,
      required: true,
      default: ''
    },
    useMerge: {
      type: Boolean,
      required: true,
      default: false
    },
    cardTypes: {
      type: String,
      required: true,
      default: ''
    },
    address: {
      type: String,
      required: true,
      default: ''
    }
  },
  methods: {
    parseCardTypes () {
      return this.cardTypes?.split(',')?.map((type, idx, arr) => type + (idx === arr?.length - 1 ? '' : ','))
    }
  }
})
